import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap, catchError } from 'rxjs/operators';
import { LoaderserviceService } from '../../services/loaderservice.service';
import { SessionServiceService } from '../../services/session-timeout/session-service.service';

@Injectable()
export class HttpserviceInterceptor implements HttpInterceptor {
  loaderService = inject(LoaderserviceService);
  private session = inject(SessionServiceService);


  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    this.loaderService.show();
    return next.handle(request).pipe(
      finalize(() => {
        if (finalize instanceof HttpResponse) {
          /* @ts-ignore */
          if (finalize.url.indexOf('renewSessionAction') == -1) {
            this.session.resetSession();
          }
        }
      }),
      tap(
        (evt) => {
          if (evt instanceof HttpResponse) {
            if (evt != null) {
              // here we are hide the loader flag
              this.loaderService.hide();
            }
          }
        },
        (err: any) => {
          this.loaderService.hide();
        },
      ),
    );
  }
}
